import Logo from "../../components/icons/Logo";
import Tap from "../../assets/img/Green-Touch-Icon.gif";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../components/Header";
import Kitchen from "../../components/icons/NavIcons/Kitchen";
import FoodHall from "../../components/icons/NavIcons/FoodHall";
import OutdoorDining from "../../components/icons/NavIcons/OutdoorDining";
import OfficesAndConferences from "../../components/icons/NavIcons/OfficesAndConferences";
import ExecutiveDiningRoom from "../../components/icons/NavIcons/ExecutiveDiningRoom";
import Cafe from "../../components/icons/NavIcons/Cafe";
import Marketplace from "../../components/icons/NavIcons/Marketplace";
import ShippingAndReceiving from "../../components/icons/NavIcons/ShippingAndReceiving";

const BusinessIndustry = () => {
    const navigate = useNavigate();
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent, location])
    return (
      <div className="page splash businessIndustryPage">
        <Header />
        <div className="page-header">Business & Industry Dining</div>
        <div className="text-blocks">
          <div className="std-text">
            Empower preference-driven dining with 
            flexible, cashless payments tailored to 
            employees, departments and guests.{'\n\n'}
            InfoGenesis supports personalized tender 
            types like payroll deduction or stored value, 
            and integrates with mobile ordering to 
            streamline transactions across channels.{'\n\n'}
            These seamless, guest-centric options 
            reduce friction, boost operational efficiency, 
            and give B&I operators the agility to meet 
            evolving workforce dining expectations.
          </div>
        </div>
        <div
          className="logo"
          onClick={() => {
            _logEvent("click", "Business & Industry", "Agilysys");
            addFlow("Agilysys");
            navigate("/aboutus/agilysys");
          }}
        >
          <Logo />
        </div>
        <div className="business-industry-map">
          <div className="kitchen">
            <Kitchen
              onClick={() => {
                _logEvent("click", "Business & Industry", "Kitchen");
                addFlow("Kitchen");
                navigate("kitchen", { relative: "path" });
              }}
            />
          </div>
          <div className="shipping-and-receiving">
            <ShippingAndReceiving
              onClick={() => {
                _logEvent("click", "Business & Industry", "Shipping & Receiving");
                addFlow("Shipping & Receiving");
                navigate("shipping", { relative: "path" });
              }}
            />
          </div>
          <div className="food-hall">
            <FoodHall 
              onClick={() => {
                _logEvent("click", "Business & Industry", "Food Hall");
                addFlow("Food Hall");
                navigate("food-hall", { relative: "path" });
              }}
            />
          </div>
          <div className="outdoor-dining">
            <OutdoorDining 
              onClick={() => {
                _logEvent("click", "Business & Industry", "Outdoor Dining");
                addFlow("Outdoor Dining");
                navigate("outdoor-dining", { relative: "path" });
              }}
            />
          </div>
          <div className="offices-and-conferences">
            <OfficesAndConferences 
              onClick={() => {
                _logEvent("click", "Business & Industry", "Offices & Conference Rooms");
                addFlow("Offices & Conference Rooms");
                navigate("offices-and-conferences", { relative: "path" });
              }}
            />
          </div>
          <div className="executive-dining-room">
            <ExecutiveDiningRoom 
              onClick={() => {
                _logEvent("click", "Business & Industry", "Executive Dining Room");
                addFlow("Executive Dining Room");
                navigate("executive-dining", { relative: "path" });
              }}
            />
          </div>
          <div className="cafe">
            <Cafe 
              onClick={() => {
                _logEvent("click", "Business & Industry", "Cafe");
                addFlow("Cafe");
                navigate("cafe", { relative: "path" });
              }}
            />
          </div>
          <div className="marketplace">
            <Marketplace 
              onClick={() => {
                _logEvent("click", "Business & Industry", "Marketplace");
                addFlow("Marketplace");
                navigate("marketplace", { relative: "path" });
              }}
            />
          </div>
        </div>
        <div className="tap">
          <img src={Tap} alt="" />
          <div className="tap-prompt">
            Tap on each section of the map{"\n"}
            To drill into the details
          </div>
        </div>
      </div>
    );
}

export default BusinessIndustry;